import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import analytics from '@/store/analytics/moduleAnalytics'
import app from '@/store/app'
import application from '@/store/application/moduleApplication'
import appConfig from '@/store/app-config'
import auth from '@/store/auth/moduleAuth'
import chat from '@/store/chat/moduleChat'
import dentalLaboratory from '@/store/dental-laboratory/moduleDentalLaboratory'
import employee from '@/store/employee/moduleEmployee'
import info from '@/store/info/moduleInfo'
import integrator from '@/store/integrator/moduleIntegrator'
import lead from '@/store/lead/moduleLead'
import notification from '@/store/notification/moduleNotification'
import patient from '@/store/patient/modulePatient'
import reports from '@/store/reports/moduleReports'
import revenue from '@/store/revenue/moduleRevenue'
import schedule from '@/store/schedule/moduleSchedule'
import serviceCalculation from '@/store/service-calculation/moduleServiceCalculation'
import settings from '@/store/settings/moduleSettings'
import todo from '@/store/todo/moduleTodo'
import verticalMenu from '@/store/vertical-menu'
import wage from '@/store/wage/moduleWage'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    analytics,
    app,
    appConfig,
    application,
    auth,
    chat,
    dentalLaboratory,
    employee,
    info,
    integrator,
    lead,
    notification,
    patient,
    reports,
    revenue,
    schedule,
    serviceCalculation,
    settings,
    todo,
    verticalMenu,
    wage,
  },
  strict: process.env.DEV,
})
